import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "buttonsRow" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "buttonsItself" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

import DialogBubble from "../layouts/DialogBubble.vue";
import { ref, watch, onMounted, inject } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TestimonialsSection',
  setup(__props) {

const container = ref();
const scrollableField = ref();
const intoView = ref();
const leftArrow = ref();
const rightArrow = ref();
const button = ref();
const displayWidth: any = inject(`displayWidth`);

watch([intoView, displayWidth], () => {
  const bubbeWidth = scrollableField.value.children[0].clientWidth;
  const calculation =
    (bubbeWidth + 0.3) * intoView.value +
    40 * intoView.value -
    container.value.clientWidth / 2 +
    bubbeWidth / 2;
  scrollableField.value.style.left = -calculation + `px`;

  button.value.forEach((i: any) => {
    i.classList.remove(`active`);
  });

  button.value[intoView.value].classList.add(`active`);

  leftArrow.value.classList.remove("blocked");
  rightArrow.value.classList.remove("blocked");

  if (intoView.value === 0) {
    leftArrow.value.classList.add("blocked");
  } else if (intoView.value === 4) {
    rightArrow.value.classList.add("blocked");
  }
});

onMounted(() => {
  intoView.value = 0;
});

return (_ctx: any,_cache: any) => {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("section", {
    ref_key: "container",
    ref: container
  }, [
    _createVNode(_component_SectionHeader, {
      title: "Testimonials",
      id: "blog",
      text: "Hear from Our Satisfied Clients: Read Our Testimonials to Learn More about Our Digital Marketing Services"
    }),
    _createVNode(_component_BaseCard, {
      styleProp: "black",
      class: "card"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "scrollableField",
          ref_key: "scrollableField",
          ref: scrollableField
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
            return _createElementVNode("div", {
              key: n,
              id: `${n}`
            }, [
              _createVNode(DialogBubble, null, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" \"We have been working with Positivus for the past year and have seen a significant increase in website traffic and leads as a result of their efforts. The team is professional, responsive, and truly cares about the success of our business. We highly recommend Positivus to any company looking to grow their online presence.\" ")
                ])),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "description" }, [
                _createElementVNode("p", { class: "name" }, "John Smith"),
                _createElementVNode("p", { class: "work" }, "Marketing Director at XYZ Corp")
              ], -1))
            ], 8, _hoisted_1)
          }), 64))
        ], 512),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: require(`../assets/right-arrow.png`),
            class: "left arrow",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (intoView.value > 0 ? intoView.value-- : null)),
            ref_key: "leftArrow",
            ref: leftArrow
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
              return _withDirectives(_createElementVNode("div", {
                key: n,
                class: "button",
                onClick: ($event: any) => (intoView.value = n - 1),
                ref_for: true,
                ref_key: "button",
                ref: button
              }, null, 8, _hoisted_5), [
                [_directive_ripple]
              ])
            }), 64))
          ]),
          _createElementVNode("img", {
            src: require(`../assets/right-arrow.png`),
            class: "arrow",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (intoView.value < 4 ? intoView.value++ : null)),
            ref_key: "rightArrow",
            ref: rightArrow
          }, null, 8, _hoisted_6)
        ])
      ]),
      _: 1
    })
  ], 512))
}
}

})